import { render } from "./CurriculumGuide.vue?vue&type=template&id=168971f5&scoped=true"
import script from "./CurriculumGuide.vue?vue&type=script&lang=js"
export * from "./CurriculumGuide.vue?vue&type=script&lang=js"

import "./CurriculumGuide.vue?vue&type=style&index=0&id=168971f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168971f5"]])

export default __exports__